const defaultState = {
  person: null,
  error: null,
  fetching: false,
  fetched: false
};

const getPersonReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'PERSON_FETCH_PENDING': {
      return {
        ...state, error: null, fetching: true
      };
    }
    case 'PERSON_FETCH_FULFILLED': {
      localStorage.setItem('person', JSON.stringify(action.payload.data.person));

      return {
        ...state, fetching: false, fetched: true, error: null, person: action.payload.data.person
      };
    }
    case 'PERSON_FETCH_REJECTED': {
      return {
        ...state, fetching: true, fetched: false, error: action.payload, person: null
      };
    }
    default: {
      break;
    }
  }

  return state;
};

export default getPersonReducer;


// WEBPACK FOOTER //
// ./src/reducers/getPerson.js